import { Theme } from '@mui/material';

export const getGlobalNotificationColor = (isRead: boolean) =>
  isRead ? (theme: Theme) => theme.palette.grey[700] : 'inherit';
